import React from 'react';
import TipsView from 'components/TipsView';
import TipLabel from 'components/TipLabel';
//关于tips的工具库

//从配置map中获取指定key的配置。配置结构。
/*
const LabelMap = {

    'first_page_title':{
        label:'验证流程首页标题',
        dec:'验证流程页面的标题文字',
        imgMap？:{ //支持相同key，不同的type，img不同
            [LITEV1]:require('images/lite/v1/first_page_title.png'),
            [LITEV2]:require('images/lite/v2/first_page_title.png')
        },
        labelMap？:{//支持相同key，不同的type，label不同
            [LITEV1]:'验证流程首页标题',
            [LITEV2]:'验证流程首页标题2'
        }
    }
};

*/
export function getTextMap(maps,key,type){
    const textMap = maps[key];
    if(!textMap) return {};
    const {labelMap,notice} = textMap;
    let label = textMap.label;
    let noticeConfig;
    if(typeof type !== 'undefined'){
        if(labelMap){
            label = labelMap[type];
        }
    }
    if(notice){
        const {imgMap,...other} = notice;
        noticeConfig = {
            ...other
        };
        if(notice.imgMap){
            noticeConfig.img = notice.imgMap[type];
        }
    }
    return {
        label,
        noticeConfig,
        textMap
    };
}

export function getLabel(maps,key,type){
    const {label,noticeConfig,textMap} = getTextMap(maps,key,type);
    if(!label) return;
    let content;
    if(noticeConfig){
        content = <TipsView textMap={noticeConfig}/>;
    }
    return <TipLabel tips={textMap.tips} label={label} content={content}/>;

}



// WEBPACK FOOTER //
// ./src/components/TipsView/tools.js